<script setup>
// Shown in place of the Closer report when the company has no AI usage left.
</script>

<template>
    <div class="flex flex-col items-center py-12 text-center">
        <div class="flex items-center justify-center w-14 h-14 mb-4 rounded-full bg-aiAgentSalesAssistant">
            <i class="text-xl text-gray-800 fa-regular fa-magnifying-glass-chart"></i>
        </div>
        <p class="max-w-sm text-sm text-gray-600">
            <mf-translate domainkey="crm:nina.error.budgetExceeded"></mf-translate>
        </p>
        <utility-ai-usage-cta class="mt-4" />
    </div>
</template>
